import { render, staticRenderFns } from "./TimeFrameButtons.vue?vue&type=template&id=0c352dc8"
import script from "./TimeFrameButtons.vue?vue&type=script&lang=js"
export * from "./TimeFrameButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports